import { routeController } from '../router/routeController'
import routerpath from '../constants/routerpath'

export const getverifiedBillsPayload = (bills) => {
  const verifiedPayload = bills?.map((data) => ({
    payeeID: data?.payeeId,
    verificationTokens: data?.verificationTokens
  }))
  return verifiedPayload
}

export const redirectToDashboard = (responsedata) => {
  const sharedData = {
    currentPath: '/',
    channel: 'OLB',
    AppFlow: 'OPENBILLPAY',
    AppError: false,
    ReturnURL: '',
    successMsg: responsedata
      ? `${responsedata} bills set up and ready to pay.`
      : '',
    payeeId: null,
    navTo: routerpath.pages.home,
    type: 'verify'
  }
  routeController(sharedData)
}
export const sortedList = (billerList) => {
  billerList.sort((a, b) =>
    a.merchantData.billerName.localeCompare(b.merchantData.billerName)
  )
  return billerList
}
export const nonRecoverableErrorCode = [
  '400.1100.4050',
  '500.1100.4000',
  '500.1100.4001',
  '500.1100.4002',
  '500.1100.4003',
  '500.1100.4004',
  '500.1100.4005',
  '500.1100.4006',
  '409'
]

export const recoverableErrorCode = [
  '409.1100.4080',
  '409.1100.4071',
  '409.2222.4090'
]
export const ProductCode = {
  PRODUCTCODE_CCD: 'CCD',
  PRODUCTCODE_BCD: 'BCD',
  PRODUCTCODE_BLN: 'BLN',
  PRODUCTCODE_SLN: 'SLN',
  PRODUCTCODE_UNL: 'UNL',
  PRODUCTCODE_EXL: 'EXL',
  PRODUCTCODE_SEL: 'SEL',
  PRODUCTCODE_LOC: 'LOC',
  PRODUCTCODE_ADP: 'ADP',
  PRODUCTCODE_MAL: 'MAL',
  PRODUCTCODE_DDA: 'DDA',
  PRODUCTCODE_LEA: 'LEA',
  PRODUCTCODE_MPA: 'MPA'
}
export const ellipsis = (data) => {
  if (typeof data !== 'string') return ''
  const string = data.replace(' - ', ' ...')
  return string
}
